module.exports = __webpack_public_path__ + "img/stone_logo.b6e686ea.png";